module.exports = __webpack_public_path__ + "static/homeHero-84ada727c744ef81cb5321ecf9a13fb8.jpg";